import {
    Container,
    useMediaQuery,
} from '@mui/material';
import React from 'react';
import Sidebar from '../../layouts/Sidebar/Sidebar';
import { validate } from '../../api/services/auth';
import SubjectListPartial from './partials/SubjectListPartial/SubjectListPartial';
import { dashboard } from '../../api/services/dashboard';
import { DashboardData, SubjectWithVideo } from '../../api/interfaces/Dashboard';
import BannerPartial from './partials/BannerPartial/BannerPartial';
import { SkeletonDashboard } from '../../components/skeleton/SkeletonDashboard/SkeletonDashboard';
import { profile } from '../../api/services/user';
import useSWR from 'swr';
import BannerPartialSkeleton from '../../components/skeleton/BannerPartialSkeleton/BannerPartialSkeleton';

const fetchValidate = () => validate();
const fetchDashboard = () => dashboard().then((res) => res.data);
const fetchProfile = () => profile().then((res) => res.data.user);

const HomePage: React.FC = () => {
    const isMobile = useMediaQuery('(max-width:600px)');

    const {
        data: validation,
        error: validateError,
        isLoading: isValidating
    } = useSWR('validate', fetchValidate);

    const {
        data: currentDashboard,
        error: dashboardError,
        isLoading: dashboardLoading,
    } = useSWR<DashboardData>(validation ? 'dashboard' : null, fetchDashboard, {

    });

    const {
        data: userProfile,
        error: profileError,
        isLoading: profileLoading,
    } = useSWR(validation ? 'profile' : null, fetchProfile, {

    });

    if (isValidating || dashboardLoading || profileLoading) {
        return (
            <>
                <main style={{ display: 'flex', flexDirection: 'column'}}>
                    <Sidebar unreadNotification={!!currentDashboard?.notifications && currentDashboard.notifications > 0} />

                    <section
                        style={{
                            flexGrow: 1,
                            marginLeft: isMobile ? 0 : 72,
                            position: 'relative',
                        }}
                    >
                        <BannerPartialSkeleton />
                        <Container
                            maxWidth={false}
                            sx={{ marginTop: '30px' }}
                        >
                            <SkeletonDashboard />
                        </Container>

                    </section>
                </main>
            </>
        );
    }

    if (validateError || dashboardError || profileError) {
        return <></>;
    }

    // Page onload
    // useEffect(() => {
    //     const run = async () => {
    //         try {
    //             await validate();
    //             const profileResponse = await profile();
    //             const userProfile = profileResponse.data.user;
    //             if (!isAccountTrial || isAccountTrial !== userProfile.isTrial) {
    //                 // Sync the account trial status
    //                 setIsAccountTrial(userProfile.isTrial ?? false);
    //             }
    //             await fetchDashboard();
    //         } catch (error) {
    //             handleApiError(error);
    //         }
    //     };

    //     run();
    // }, [fetchDashboard, navigate]);

    return (
        <main style={{ display: 'flex', flexDirection: 'column'}}>
            <Sidebar unreadNotification={!!currentDashboard?.notifications && currentDashboard.notifications > 0} />

            <section
                style={{
                    flexGrow: 1,
                    marginLeft: isMobile ? 0 : 72,
                    position: 'relative',
                }}
            >
                <BannerPartial currentDashboard={currentDashboard} />

                <Container
                    maxWidth={false}
                    sx={{ marginTop: '30px' }}
                >
                    <>

                        {
                            currentDashboard?.recentlyViewedVideos && currentDashboard.recentlyViewedVideos.length > 0 && (
                                <SubjectListPartial
                                    key="RECENTLY_WATCHED_KEY"
                                    title="Recently Watched"
                                    videos={currentDashboard?.recentlyViewedVideos}
                                    isControlsEnabled={isMobile ? true : false}
                                    isShowAllEnabled={false}
                                    isSliderEnabled={isMobile ? true : false}
                                    isAccountTrial={userProfile?.isTrial ?? false}
                                    isRecentlyWatch={true}
                                />
                            )
                        }
                        {/* List of videos per subject */}
                        {
                            currentDashboard?.subjects?.map((subject: SubjectWithVideo) => (
                                <SubjectListPartial
                                    key={subject._id}
                                    subjectId={subject._id}
                                    title={subject.name}
                                    videos={subject.videos}
                                    isControlsEnabled={true}
                                    isShowAllEnabled={true}
                                    isSliderEnabled={true}
                                    isAccountTrial={userProfile?.isTrial ?? false}
                                />
                            ))
                        }
                    </>
                </Container>
            </section>
        </main>
    );
};

export default HomePage;
